export enum ButtonTextModal {
  ACEPTAR = 'Aceptar',
  REGRESAR = 'Regresar',
}
